import { Spin, Tooltip } from 'antd';
import { CSSProperties, FC } from 'react';
import styled from '@emotion/styled';
import StateIcon, { JobStatusType } from 'packages/lib/common-ui/state-icon';
import { ErrorOutline } from '@mui/icons-material';
import { JobStatus } from 'packages/lib/api/logminer/contract/log-miner-types';

export const StatusIconContainer = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 8px;
  margin-left: 5px;
  margin-bottom: 2px;
  color: white;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 5px;
`;

const styles: { [name: string]: CSSProperties } = {
  statusIcon: {
    width: '17px',
    height: '17px',
    marginLeft: '4px',
    marginTop: '2px',
  },
};

interface ResultStatusIconProps {
  jobStatus: JobStatus | null;
  isLoading: boolean;
}

export const ResultStatusIcon: FC<
  React.PropsWithChildren<ResultStatusIconProps>
> = ({ isLoading, jobStatus }): JSX.Element | null => {
  if (isLoading) {
    return (
      <StatusIconContainer>
        <Spin style={{ filter: 'brightness(2.0)' }} />
      </StatusIconContainer>
    );
  }

  if (jobStatus) {
    return (
      <Tooltip
        title={
          jobStatus.status === JobStatusType.Succeeded
            ? 'Scene successfully imported into annotations on ' +
              new Date(jobStatus.created_timestamp).toLocaleString()
            : 'Sent to annotations on ' +
              new Date(jobStatus.created_timestamp).toLocaleString() +
              '. Status: ' +
              jobStatus.status
        }
      >
        <StatusIconContainer>
          <StateIcon
            state={(jobStatus.status + 'bright') as JobStatusType}
            style={styles.statusIcon}
            missingStateIcon={ErrorOutline}
          />
        </StatusIconContainer>
      </Tooltip>
    );
  }

  return null;
};
